var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpIco5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emp-ico-5",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.468,
    height: 13.468,
    viewBox: "0 0 13.468 13.468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3661",
    "data-name": "Path 3661",
    d: "M0,0H13.468V13.468H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3662",
    "data-name": "Path 3662",
    d: "M7.489,12.856H4.122A1.122,1.122,0,0,1,3,11.734V6.122A1.122,1.122,0,0,1,4.122,5h7.856A1.122,1.122,0,0,1,13.1,6.122V9.489",
    transform: "translate(-1.317 -2.194)",
    fill: "none",
    stroke: "#7e7280",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3663",
    "data-name": "Path 3663",
    d: "M3,7l5.05,3.367L13.1,7",
    transform: "translate(-1.317 -3.072)",
    fill: "none",
    stroke: "#7e7280",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3664",
    "data-name": "Path 3664",
    d: "M15,18.122l1.122,1.122L18.367,17",
    transform: "translate(-6.583 -7.46)",
    fill: "none",
    stroke: "#7e7280",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpIco5);
export default __webpack_public_path__ + "static/media/emp-ico-5.98ee4ed51e2d04edf3d173a94375994e.svg";
export { ForwardRef as ReactComponent };